import { createContext } from 'react'

export type ColorModeContextType = {
  mode: string
}

export const ColorModeContext = createContext<ColorModeContextType>(
  {} as ColorModeContextType
)
